export const ZOOM_LEVELS = [1, 1.5, 2, 3];

/** 1 = 100%, 2 = 1.5×, 3 = 2×, 4 = 3× (index into {@link ZOOM_LEVELS}) */
export function zoomLevelToIndex(level: number | undefined): number {
    const l = level ?? 1;
    if (Number.isInteger(l) && l >= 1 && l <= ZOOM_LEVELS.length) {
        return l;
    }
    const idx = ZOOM_LEVELS.indexOf(l);
    return idx >= 0 ? idx + 1 : 1;
}

/** Scale factor applied via CSS transform */
export function zoomLevelToScale(level: number | undefined): number {
    return ZOOM_LEVELS[zoomLevelToIndex(level) - 1];
}

/** Map bar preset scale (1.5 | 2 | 3) to stored zoom index (2 | 3 | 4) */
export function zoomPresetScaleToLevel(presetScale: number): number {
    const idx = ZOOM_LEVELS.indexOf(presetScale);
    return idx >= 0 ? idx + 1 : 1;
}

export const ZOOM_BAR_PRESETS = [
    {
        id: 'x1_5',
        zoomMultiplier: 1.5,
        labelKey: 'zoom.buttons.text.zoomX1.5',
    },
    {
        id: 'x2',
        zoomMultiplier: 2,
        labelKey: 'zoom.buttons.text.zoomX2',
    },
    {
        id: 'x3',
        zoomMultiplier: 3,
        labelKey: 'zoom.buttons.text.zoomX3',
    },
] as const;

export type ZoomBarPreset = (typeof ZOOM_BAR_PRESETS)[number];
export type ZoomBarPresetId = ZoomBarPreset['id'];
